module.exports = __webpack_public_path__ + "static/button-retention-83b8a9e750631bed667097545900f18f.svg";